import axios from "../../config/axiosConfig";
import { TABLE_VERSION_REQUEST, TABLE_VERSION_SUCCESS, TABLE_VERSION_FAILURE } from "../types";

export const getTablesVersions = (tables) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: TABLE_VERSION_REQUEST });

      return axios.get("/version/get", { params: { tables } }).then((response) => {
        if (response.data) {
          dispatch({ type: TABLE_VERSION_SUCCESS, payload: response.data });
        }
        return response.data || {};
      }).catch((error) => {
        console.error(error);
        dispatch({ type: TABLE_VERSION_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: TABLE_VERSION_FAILURE, error: error.message });
    }
  };
};